import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"success\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-5-5h40v40H-5z\" /><path fill=\"#fff\" fill-rule=\"nonzero\" d=\"M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-3c6.627 0 12-5.373 12-12S21.627 3 15 3 3 8.373 3 15s5.373 12 12 12zm-3.31-6.44l-4.5-4.5a1.5 1.5 0 0 1 2.12-2.12l3.44 3.46 7.19-7.21a1.5 1.5 0 0 1 2.12 2.12l-8.25 8.25a1.5 1.5 0 0 1-2.12 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol